const rules = {};

rules.differentValues = {
    code: 'different-values',
};

rules.minAge = {
    code: 'min-age',
};

rules.maxAge = {
    code: 'max-age',
};

rules.minValue = {
    code: 'min-value',
};

rules.maxValue = {
    code: 'max-value',
};

rules.minLength = {
    code: 'min-length',
};

rules.maxLength = {
    code: 'max-length',
};

rules.futureDate = {
    code: 'future-date',
};

rules.pastDate = {
    code: 'past-date',
};

rules.todayFutureDate = {
    code: 'today-future-date',
};

rules.todayPastDate = {
    code: 'today-past-date',
};

rules.integer = {
    code: 'integer',
};
rules.afterEqualSpecificDate = {
    code: 'after-equal-specific-date',
};

rules.afterSpecificDate = {
    code: 'after-specific-date',
};

rules.beforeEqualSpecificDate = {
    code: 'before-equal-specific-date',
};

rules.beforeSpecificDate = {
    code: 'before-specific-date',
};

rules.pastSpecificDate = {
    code: 'past-specific-date',
};

rules.futureSpecificDate = {
    code: 'future-specific-date',
};

export default rules;
